import { Checkbox } from "@octopusdeploy/design-system-components";
import type { EnvironmentV2Resource, ProjectResource } from "@octopusdeploy/octopus-server-client";
import { Permission, TenantedDeploymentMode } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import PermissionCheck from "~/components/PermissionCheck/PermissionCheck";
import { Select } from "~/components/form";
import type { Item } from "~/primitiveComponents/form/Select/Select";
import styles from "./style.module.less";
interface VariableScopeSelectorProps {
    project: ProjectResource;
    environments: EnvironmentV2Resource[];
    environmentId?: string;
    tenants: Item[];
    tenantId?: string;
    actions: Item[];
    actionId?: string;
    channels: Item[];
    channelId?: string;
    machines: Item[];
    machineId?: string;
    showOctopus: boolean;
    filterEmptyValues: boolean;
    onEnvironmentChanged: (environmentId: string | undefined) => void;
    onTenantChanged: (tenantId: string | undefined) => void;
    onActionChanged: (actionId: string | undefined) => void;
    onChannelChanged: (channelId: string | undefined) => void;
    onMachineChanged: (machineId: string | undefined) => void;
    onShowOctopusChanged: (showOctopus: boolean) => void;
    onFilterEmptyValuesChanged: (filterEmptyValues: boolean) => void;
}
export function VariableScopeSelector({ project, environments, environmentId, tenants, tenantId, actions, actionId, channels, channelId, machines, machineId, showOctopus, filterEmptyValues, onEnvironmentChanged, onTenantChanged, onActionChanged, onChannelChanged, onMachineChanged, onShowOctopusChanged, onFilterEmptyValuesChanged, }: VariableScopeSelectorProps) {
    return (<div className={styles.scopeRow}>
            <h4>Select Deployment Scenario</h4>
            <Select label="Environment" items={environments.map((env) => ({ value: env.Id, text: env.Name }))} allowClear={false} value={environmentId} onChange={onEnvironmentChanged} sortItems={true}/>
            {tenants && tenants.length > 0 && <Select label="Tenant" items={tenants} allowClear={project.TenantedDeploymentMode !== TenantedDeploymentMode.Tenanted} value={tenantId} onChange={onTenantChanged} placeholder="Untenanted"/>}
            <PermissionCheck permission={Permission.ProcessView} project={project.Id} wildcard={true}>
                <Select label="Deployment step" items={actions} allowClear={false} value={actionId} onChange={onActionChanged}/>
                {channels && channels.length > 1 && <Select label="Channel" items={channels} allowClear={false} value={channelId} onChange={onChannelChanged}/>}
            </PermissionCheck>
            <Select label="Deployment target" items={machines} allowFilter={true} allowClear={true} value={machineId} onChange={onMachineChanged} placeholder="Select deployment target"/>
            <div className={styles.showAll}>
                <Checkbox label="Show system variables" value={showOctopus} onChange={onShowOctopusChanged}/>
                <Checkbox label="Filter empty values" value={filterEmptyValues} onChange={onFilterEmptyValuesChanged}/>
            </div>
        </div>);
}
